import React, {Component} from 'react';
import './App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Autosuggest from 'react-autosuggest';

import {urlConfig} from './config'

const styles = theme => ({
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 2,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing(2),
    },
    container: {
        position: 'relative',
    },
    input: {
        fontSize: "larger"
    }
});

function renderInputComponent(inputProps) {
    const {
        classes, inputRef = () => {
        }, ref, ...other
    } = inputProps;

    return (
        <TextField
            fullWidth
            InputProps={{
                inputRef: node => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
            }}
            {...other}
        />
    );
}


class AutocompleteSearch extends Component {

    serverBase = urlConfig.bffUrl;

    constructor(props) {
        super(props);

        this.state = {
            suggestions: [],
            cid: this.cid,
            errorMessages: {},
            inputSearchText: '',
        };

        this.inputPlaceholder = props.inputPlaceholder;
    }

    componentDidMount() {

    }


    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.inputSearchText === "toClearInputSearchText") {
            this.setState({inputSearchText: ''})
        }
    }

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };


    handleChangeVal = name => (event, {newValue}) => {
        this.setState({
            [name]: newValue,
        });
    };

    onKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };
    handleSuggestionsFetchRequested = ({value}) => {

        let self = this;

        this.props.handleSearchRequest(value).then((response) => {
            if (response.data && response.data.entity && response.data.entity.length > 0) {
                self.setState({suggestions: response.data.entity}, () => {

                })
            } else if (response.data && response.data.length > 0) {
                self.setState({suggestions: response.data}, () => {

                })
            }

        });
    };

    render() {
        const {classes, theme, getSuggestionValue, renderSuggestion} = this.props;
        const flex = {flexGrow: 1};
        let autosuggestProps = {
            renderInputComponent,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            getSuggestionValue,
            renderSuggestion,
            focusInputOnSuggestionClick: false
        };

        const inputStyle = {
            maxWidth: '10rem'
        };


        return (

            <Autosuggest style={flex} suggestions={this.state.suggestions || []}
                         onSuggestionSelected={this.props.handleSuggestionSelected.bind(this)}
                         {...autosuggestProps}
                         inputProps={{
                             classes,
                             placeholder: `${this.inputPlaceholder}`,
                             value: this.state.inputSearchText,
                             onChange: this.handleChangeVal('inputSearchText'),
                             onKeyPress: this.onKeyPress
                         }}
                         theme={{
                             container: classes.container,
                             suggestionsContainerOpen: classes.suggestionsContainerOpen,
                             suggestionsList: classes.suggestionsList,
                             suggestion: classes.suggestion,
                         }}
                         renderSuggestionsContainer={options => (
                             <Paper {...options.containerProps} square>
                                 {options.children}
                             </Paper>
                         )}
            />

        );
    }
}


AutocompleteSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
export default withStyles(styles, {withTheme: true})(AutocompleteSearch);
